module.exports = __webpack_public_path__ + "static/media/add-circle.aaa3658f.svg";